<template>
    <div class="benchmark-pools-settings-panel">
        <h4>Benchmark pools</h4>
        <p class="panel-hint">Create, edit or delete pools here. Save a pool draft to update the leaderboards and indices using it. Cancel discards unsaved edits.</p>
        <benchmark-pool-fields v-if="props.active && hasAccess" ref="poolEditor" :persist-selection="false" />
        <p v-else-if="props.active && !hasAccess" role="status">{{ Messages.CustomIndexAccessRequired }}</p>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BenchmarkPoolFields from '@/components/powerMarkets/BenchmarkPoolFields.vue';
import { useIndexStore } from '@/stores/benchmarks/indexStore.ts';
import { Messages } from '@/constants/Messages.ts';

const props = withDefaults(defineProps<{ active?: boolean }>(), { active: true });
const indexStore = useIndexStore();
const hasAccess = computed(() => indexStore.userCustomAccessIndexCountries.some(country => country.accessKey === 'Gb'));
const poolEditor = ref<InstanceType<typeof BenchmarkPoolFields> | null>(null);
async function requestLeave (): Promise<boolean> {
    return await poolEditor.value?.requestLeave() ?? true;
}
defineExpose({ requestLeave });
</script>

<style lang="scss" scoped>
.benchmark-pools-settings-panel {
    display: flex;
    flex-direction: column;
    gap: var(--largeSpacing);
    padding: var(--largeSpacing) 0;
}
.panel-hint {
    margin: 0;
    color: var(--neutral600);
    font-size: var(--smallFontSize);
}
</style>
